import { styled } from '@mui/material/styles';

export const HeadingWrapper = styled('div', {
  shouldForwardProp: prop => prop !== 'fullWidth',
})(({ theme, fullWidth }) => ({
  padding: theme.spacing(1, 0),
  width: 'fit-content',
  '*': {
    color: theme.palette.text.secondary,
  },

  'h1, h2, h3, h4, h5, h6': {
    color: theme.palette.text.primary,

    '& *': {
      color: 'inherit',
    },
  },

  'h1:only-child': {
    ...theme.typography.h1Redesign,
    color: theme.palette.primary.dark,
    margin: 0,
    textAlign: 'left',

    '& *': {
      color: 'inherit',
    },

    [theme.breakpoints.down('md')]: {
      ...theme.typography.h2Redesign,
      textAlign: 'center',
    },
  },

  // Headings
  h1: {
    ...theme.typography.h1Redesign,
    wordBreak: 'break-word',
    hyphens: 'auto',
  },
  h2: {
    ...theme.typography.h2Redesign,
    overflowWrap: 'break-word',
  },
  h3: {
    ...theme.typography.h3Redesign,
    breakAfter: 'avoid',
    pageBreakAfter: 'avoid',
  },
  h4: theme.typography.h4Redesign,
  h5: theme.typography.h5Redesign,
  h6: theme.typography.h6Redesign,

  'h1, h2, h3': {
    marginTop: theme.spacing(4),
    marginBottom: theme.spacing(4),
  },

  'h1 strong, h2 strong, h3 strong, h4 strong': {
    fontWeight: 'inherit',
  },

  // Paragraphs and lists
  '& p, & ul, & ol': {
    ...theme.typography.body1Redesign,
    marginTop: theme.spacing(4),
    marginBottom: theme.spacing(4),
  },
  '& p:has(> img)': {
    marginTop: theme.spacing(6),
    marginBottom: theme.spacing(6),
  },
  figure: {
    marginTop: `${theme.spacing(6)} !important`,
    marginBottom: `${theme.spacing(6)} !important`,
  },
  p: { breakInside: 'avoid' },
  ul: {
    paddingLeft: 0,
    listStyle: 'none',
  },
  ol: {
    counterReset: 'item',
    paddingInlineStart: 0,
  },
  '& ul li, & ol li': {
    paddingLeft: theme.spacing(3.5),
    position: 'relative',
  },
  '& ul li:before, & ol li:before': {
    position: 'absolute',
    fontWeight: 'bold',
    top: 0,
    left: 0,
  },
  '& ol li': {
    display: 'block',
  },
  '& ol li:before': { content: "counter(item) '. '", counterIncrement: 'item' },
  '& ul li:before': {
    content: '"• "',
  },
  '& li + li': {
    marginTop: theme.spacing(1),
  },
  a: {
    color: theme.palette.primary.main,
    fontStyle: 'normal',
    textDecoration: 'underline',
    wordBreak: 'break-word',
  },
  img: {
    maxWidth: '100%',
    borderRadius: 15,
  },

  // Embedded content
  '& [data-oembed][data-oembed-provider="YouTube"]': {
    position: 'relative',
    width: '100%',
    height: 0,
    paddingBottom: '50%',
  },
  '& [data-oembed] iframe': {
    width: '100%',
  },
  '& [data-oembed][data-oembed-provider="YouTube"] iframe': {
    position: 'absolute',
    minWidth: '100%',
    height: '100%',
    left: 0,
    top: 0,
  },

  [theme.breakpoints.up('md')]: {
    maxWidth: fullWidth ? '100%' : '65%',
  },

  [theme.breakpoints.down('sm')]: {
    '& p.block-img, & [data-oembed] iframe': {
      width: 'calc(100% + 4.5rem)',
      marginLeft: `-${theme.pageMarginHorizontalMobile}`,
    },
    '& [data-oembed][data-oembed-provider="YouTube"]': {
      paddingBottom: '70%',
    },
    '& [data-oembed][data-oembed-provider="YouTube"] iframe': {
      marginLeft: 0,
      left: `-${theme.pageMarginHorizontalMobile}`,
      width: 'calc(100% + 4.5rem)',
    },
  },
}));

export const ImageWrapperOuter = styled('div')(({ theme }) => ({
  position: 'relative',
  width: '100%',
  height: 160,
  [theme.breakpoints.up('md')]: {
    position: 'unset',
    width: 'unset',
    height: 'unset',
  },
}));

export const ImageWrapperInner = styled('div')(({ theme }) => ({
  position: 'absolute',
  zIndex: theme.zIndex.heroImage,
  top: -64,
  right: 0,
  bottom: -64,
  left: 0,
}));
